export default {
    namespaced:true,
    state:{
        projectId:"",
        sign_name:"",
        settings_pdf:{'len_2_show': 30, 'skip_word_num':0, "is_ocr": 1, img_sim_threshold: "1"},
        processData:{},
        catelogueData:[],
        evaluationData:{

        },
        isFinished:false,
        hasImg:false,
        hasAuthor:false,
        hasErrText:false,
        hasPara:false

    },
    mutations:{
        set_projectId_pdf(state,projectId){
            state.projectId = projectId
        },
        changeSettings_pdf(state,settings){
            state.settings_pdf = settings;
        },
        set_signName_pdf(state,sign_name){
            state.sign_name = sign_name;
        },
        setProcessData(state,processData){
            state.processData = processData;
        },
        setCatelogueData(state,data){
            state.catelogueData = data;
        },
        setEvaluationData(state,data){
            state.evaluationData = data;
        },
        setFinished(state,data){
            state.isFinished = data;
        },
        setHasImg(state,hasImg){
            state.hasImg = hasImg
        },
        setHasAuthor(state,hasAuthor){
            state.hasAuthor = hasAuthor
        },
        setHasErrText(state,hasErrText){
            state.hasErrText = hasErrText
        },
        setHasPara(state,hasPara){
            state.hasPara = hasPara
        }


    }
}
